export default {
  namespaced: true,
  pagination: {
    title: "Pagination",
    page: "Page:",
    cancel: "Cancel",
    page_not_found:"Page not found",
    next_page: "Next",
    prev_page: "Previous",
  },
};
